import type { LocationQuery } from 'vue-router'

import { getQueryParam } from '@/utils/route'

export const ANALYTICS_EVENTS = {
  // Signup
  SIGNUP_PAGE_VIEWED: 'signup_page_viewed',
  SIGNUP_STARTED: 'signup_started',
  ACCOUNT_CREATED: 'account_created',
  // Hyphen kept deliberately: renaming would split this from the data already in Mixpanel
  BUSINESS_REGISTERED: 'business-registered',

  // Signup drop-off
  STARTER_SIGNUP_SKIPPED: 'starter_signup_skipped',
  UPGRADE_PROMPT_DECLINED: 'upgrade_prompt_declined',
  TC_MODAL_DISMISSED: 'tc_modal_dismissed',

  // Signing
  INVITE_PAGE_VIEWED: 'invite_page_viewed',
  SIGNATURE_REQUEST_SENT: 'signature_request_sent',
  SIGNATURE_REQUEST_CREATION: 'signature_request_creation',
  SIGNATURE_REQUEST_SAVED: 'signature_request_saved',
  SIGNING_FAILED: 'signing_failed',
  SIGN_NOW_CLICKED: 'sign_now_clicked',
  TC_MODAL_VIEWED: 'tc_modal_viewed',
  TC_ACCEPTED: 'tc_accepted',
  DOCUMENT_SIGNED_AS_INVITEE: 'document_signed_as_invitee',

  // Referral
  REFERRAL_WIDGET_OPENED: 'referral_widget_opened',
  REFERRAL_LINK_CLICKED: 'referral_link_clicked',
  REFERRAL_SIGNUP_COMPLETED: 'referral_signup_completed',

  // Plans
  STARTER_PLAN_DIALOG_VIEWED: 'starter_plan_dialog_viewed',
  STARTER_TRIAL_ACTIVATED: 'starter_trial_activated',
  UPGRADE_PROMPT_VIEWED: 'upgrade_prompt_viewed',

  // Email domains
  DOMAIN_CONFIGURE_STARTED: 'domain_configure_started',
  DOMAIN_CONFIGURE_DISMISSED: 'domain_configure_dismissed',
  DOMAIN_DNS_RECORDS_COPIED: 'domain_dns_records_copied',
  DOMAIN_VERIFY_ATTEMPTED: 'domain_verify_attempted',
  DOMAIN_SMTP_RELAY_BLOCKED: 'domain_smtp_relay_blocked',
} as const

export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]

export type SignupSource = 'pricing' | 'nas-conversion' | 'in-app-upgrade' | 'referral-cello' | 'none'

export const SIGNATURE_REQUEST_STEPS = {
  UPLOAD: 'upload',
  REVIEW_DOCUMENTS: 'review_documents',
  LEGAL_WEIGHT: 'legal_weight',
  SIGNERS: 'signers',
  PLACEMENT: 'placement',
  FINALIZE: 'finalize',
} as const

export type SignatureRequestCreationStep = (typeof SIGNATURE_REQUEST_STEPS)[keyof typeof SIGNATURE_REQUEST_STEPS]

const SIGNUP_PLANS = ['starter', 'team', 'pro'] as const

export type SignupPlan = (typeof SIGNUP_PLANS)[number]

export interface SignupContext {
  source: SignupSource
  plan?: SignupPlan
}

// The marketing site still links ?plan=starter; drop the fallback once it ships ?cta_plan=.
export function getCtaPlan(query: LocationQuery): SignupPlan | undefined {
  const plan = getQueryParam<string>(query.cta_plan) || getQueryParam<string>(query.plan)
  return SIGNUP_PLANS.find(known => known === plan)
}

export function getEntrySource(query: LocationQuery): SignupSource {
  return getCtaPlan(query) ? 'pricing' : 'none'
}
